import Tcf from './Tcf'
import { createLog } from '../logger'

const log = createLog()
const locationMap = window.location.hash.substr(1).split(',').map(kv => kv.split('=')).reduce((acc, [k, v]) => ({ ...acc, ...{ [k]: v } }), {})
const brokerId = locationMap.brokerId

const molAdsTcfKey = 'mol.ads.cmp.tcf'
const customVendorKey = 'mol.ads.cmp.customVendors'

const message = {
  ns: '@mol-ads/mol-ads-cmp',
  id: brokerId,
  sender: 'mol-ads/mol-ads-cmp-storage',
  action: 'storageLoaded'
}

const canUseLocalStorage = () => {
  try {
    const testKey = 'mol.ads.cmp.test'
    localStorage.setItem(testKey, testKey)
    localStorage.removeItem(testKey)
    return true
  } catch (e) {
    console.warn('Cannot use localStorage')
    return false
  }
}

function updateStorage (tcf, key, data) {
  if (data.cmpStatus === 'loaded' && data.tcString.length !== 0 && (data.eventStatus === 'tcloaded' || data.eventStatus === 'useractioncomplete')) {
    log('updating storage', data)
    localStorage.setItem(key, JSON.stringify(data))
    tcf.call(false, 'getCustomVendorsConsents', data => {
      log('updating customVendors storage', data)
      localStorage.setItem(customVendorKey, JSON.stringify(data))
    })
  }
}

function tcfHasLoaded () {
  return new Promise((resolve) => {
    window.addEventListener('message', (event) => {
      const { ns, id, action } = event.data || {}
      if (ns === '@mol-ads/mol-ads-cmp' && action === 'is_loaded' && id === brokerId) {
        resolve()
      }
    })
  })
}

const loadCustomVendorsConsents = () => {
  try {
    return JSON.parse(localStorage.getItem(customVendorKey) || '{}')
  } catch (e) {
    return {}
  }
}

export default async function launch () {
  if (canUseLocalStorage()) {
    const stringifiedTcData = localStorage.getItem(molAdsTcfKey)
    const tcData = stringifiedTcData && JSON.parse(stringifiedTcData)
    const customVendorsConsents = loadCustomVendorsConsents()
    const pTcfHasLoaded = tcfHasLoaded()
    window.parent.postMessage({
      ...message,
      payload: {
        canStoreUserPreference: true,
        tcData,
        customVendors: { consents: customVendorsConsents }
      }
    }, '*')
    await pTcfHasLoaded
    const tcf = new Tcf()
    tcf.call(true, 'addEventListener', data => {
      updateStorage(tcf, molAdsTcfKey, data)
    })
    tcf.call(false, 'getTCData', data => {
      updateStorage(tcf, molAdsTcfKey, data)
    })
  } else {
    window.top.postMessage({
      ...message,
      payload: { canStoreUserPreference: false }
    }, '*')
  }
}
